<h2 class="gw-rd-page-widget-title">
    <slot />
</h2>

<style lang="postcss">
    .gw-rd-page-widget-title {
        margin: 0;
        font-size: clamp(24px, 9px + 3vw, 32px);
        font-weight: 700;
        line-height: clamp(32px, 26.4px + 1.8vw, 40px);
        color: var(--gw-rd-primary-color);
    }
</style>
